import { render, staticRenderFns } from "./DeleteCategoryDialog.vue?vue&type=template&id=735c4c6c&"
import script from "./DeleteCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteCategoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports